(function () {
  'use strict';
  if (window.productCardJsLoaded) return;
  window.productCardJsLoaded = true;

  document.addEventListener('click', function (e) {
    var moreBtn = e.target.closest('.product-card__swatch-more');
    if (moreBtn) {
      e.preventDefault();
      var swatchesWrap = moreBtn.closest('.product-card__swatches');
      if (swatchesWrap) {
        swatchesWrap.classList.add('is-expanded');
        swatchesWrap.querySelectorAll('.product-card__swatch').forEach(function (sw) {
          sw.style.display = '';
        });
      }
      return;
    }

    var swatch = e.target.closest('.product-card__swatch[data-card-image]');
    if (!swatch) return;
    e.preventDefault();
  
    var card = swatch.closest('.product-card');
    if (!card) return;
  
    var img = card.querySelector('.product-card__img');
    if (!img) return;
  
    img.src = swatch.dataset.cardImage;
    img.removeAttribute('srcset');
    img.alt = swatch.dataset.cardImageAlt || img.alt;
  
    card.querySelectorAll('.product-card__swatch').forEach(function (btn) {
      btn.classList.toggle('is-active', btn === swatch);
    });
  });
  /* ================================================================
     COUNTDOWN TIMERS
     Looks for [data-countdown] elements and ticks them down.
  ================================================================ */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var startTime = el.dataset.countdownStart ? parseCountdownDate(el.dataset.countdownStart) : NaN;
      var endTime = parseCountdownDate(el.dataset.countdown);
      if (isNaN(endTime)) return;

      var numH = el.querySelector('[data-cd="h"]');
      var numM = el.querySelector('[data-cd="m"]');
      var numS = el.querySelector('[data-cd="s"]');
      var upcomingEl = el.querySelector('[data-cd-upcoming]');
      var digitsEl = el.querySelector('[data-cd-digits]');

      function pad(n) { return String(n).padStart(2, '0'); }

      /* - sebelum start → Upcoming / 00:00:00
         - selama sale  → sisa waktu sampai end
         - setelah end  → hide countdown */
      function getRemainingMs() {
        var now = Date.now();
        if (!isNaN(startTime) && now < startTime) return 0;
        if (now >= endTime) return 0;
        return endTime - now;
      }

      function hideCountdown() {
        el.hidden = true;
        el.setAttribute('aria-hidden', 'true');
        el.classList.add('is-ended');
      }

      function setUpcoming(isUpcoming) {
        el.classList.toggle('is-upcoming', isUpcoming);
        if (upcomingEl) upcomingEl.hidden = !isUpcoming;
        if (digitsEl) digitsEl.hidden = isUpcoming;
      }

      function tick() {
        var now = Date.now();

        if (now >= endTime) {
          hideCountdown();
          return;
        }

        var isUpcoming = !isNaN(startTime) && now < startTime;
        setUpcoming(isUpcoming);

        var diff = getRemainingMs();
        var totalHours = Math.floor(diff / 3600000);
        if (numH) numH.textContent = String(totalHours).padStart(2, '0');
        if (numM) numM.textContent = pad(Math.floor((diff % 3600000) / 60000));
        if (numS) numS.textContent = pad(Math.floor((diff % 60000) / 1000));
        setTimeout(tick, 1000);
      }

      tick();
    });
  }

  function parseCountdownDate(value) {
    if (!value) return NaN;

    var normalized = value.trim();
    var dateMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})[.\sT](\d{1,2}):(\d{2})$/);

    if (dateMatch) {
      return new Date(
        parseInt(dateMatch[1], 10),
        parseInt(dateMatch[2], 10) - 1,
        parseInt(dateMatch[3], 10),
        parseInt(dateMatch[4], 10),
        parseInt(dateMatch[5], 10),
        0
      ).getTime();
    }

    return new Date(normalized).getTime();
  }

  /* ================================================================
     FEATURED PRODUCT CAROUSELS
     Scroll-based carousel with prev/next arrows.
  ================================================================ */
  function initFeaturedCarousels() {
    document.querySelectorAll('[data-fp-carousel]').forEach(function (wrap) {
      var track   = wrap.querySelector('[data-fp-track]');
      var prevBtn = wrap.querySelector('[data-fp-prev]');
      var nextBtn = wrap.querySelector('[data-fp-next]');
      if (!track) return;

      function scrollBy(dir) {
        var card = track.querySelector('.product-card');
        var step = card ? (card.offsetWidth + 16) * 2 : 432;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollBy(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollBy(1); });
    });
  }

  /* ================================================================
     VARIANT POPUP
     Opens when a "Select Variant" button is clicked.
     Fetches product JSON, builds option selectors, handles ATC.
  ================================================================ */
  var popup       = document.getElementById('variant-popup');
  var popOverlay  = popup ? popup.querySelector('.variant-popup__overlay') : null;
  var popClose    = popup ? popup.querySelector('.variant-popup__close')   : null;
  var popTitle      = popup ? popup.querySelector('[data-vp-title]')         : null;
  var popSku        = popup ? popup.querySelector('[data-vp-sku]')           : null;
  var popPriceRange = popup ? popup.querySelector('[data-vp-price-range]')   : null;
  var popFinalPrice = popup ? popup.querySelector('[data-vp-final-price]')   : null;
  var popStock      = popup ? popup.querySelector('[data-vp-stock]')         : null;
  var popOptions    = popup ? popup.querySelector('[data-vp-options]')       : null;
  var popQtyInput   = popup ? popup.querySelector('[data-vp-qty]')           : null;
  var popQtyDec     = popup ? popup.querySelector('[data-vp-qty-dec]')       : null;
  var popQtyInc     = popup ? popup.querySelector('[data-vp-qty-inc]')       : null;
  var popAtcBtn     = popup ? popup.querySelector('[data-vp-atc]')           : null;
  var popGallery    = popup ? popup.querySelector('[data-vp-gallery]')       : null;
  var popDots       = popup ? popup.querySelector('[data-vp-dots]')          : null;

  var currentProduct = null;
  var selectedOptions = {};
  var galleryImages   = [];
  var currentImg      = 0;

  var scrollTopPos = 0;

  function openPopup() {
    if (!popup) return;
    scrollTopPos = window.scrollY;
    popup.classList.add('is-open');
    popup.removeAttribute('aria-hidden');
    
    // Scroll lock to prevent background jumping to top
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollTopPos + 'px';
    document.body.style.width = '100%';
    
    document.body.classList.add('variant-popup-open');
    document.documentElement.classList.add('variant-popup-open');
    var popBody = popup.querySelector('.variant-popup__body');
    if (popBody) popBody.scrollTop = 0;
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    
    // Release scroll lock
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    
    document.body.classList.remove('variant-popup-open');
    document.documentElement.classList.remove('variant-popup-open');
    
    window.scrollTo(0, scrollTopPos);

    currentProduct  = null;
    selectedOptions = {};
    galleryImages   = [];

    var wasGiftTierId = popup.dataset.gwpTierId;
    var wasClaimed = popup.dataset.gwpClaimed === 'true';
    delete popup.dataset.gwpTierId;
    delete popup.dataset.gwpClaimed;
    popup.classList.remove('gwp-variant-mode');

    if (wasGiftTierId && !wasClaimed && typeof window.__gwpOnPopupSkipped === 'function') {
      window.__gwpOnPopupSkipped(wasGiftTierId);
    }
  }

  if (popClose)   popClose.addEventListener('click', closePopup);
  if (popOverlay) popOverlay.addEventListener('click', closePopup);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup && popup.classList.contains('is-open')) closePopup();
  });

  /* Quantity stepper */
  if (popQtyDec) {
    popQtyDec.addEventListener('click', function () {
      var v = parseInt(popQtyInput.value, 10) || 1;
      if (v > 1) popQtyInput.value = v - 1;
    });
  }
  if (popQtyInc) {
    popQtyInc.addEventListener('click', function () {
      var v = parseInt(popQtyInput.value, 10) || 1;
      popQtyInput.value = v + 1;
    });
  }

  /* Delegate "Select Variant" button clicks */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vp-open]');
    if (!btn) return;
    var handle = btn.dataset.vpOpen;
    if (!handle) return;
    loadProduct(handle);
  });

  /* Delegate "Add to Cart" direct clicks (no-variant products) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-atc-id]');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.dataset.atcId;
    if (!variantId) return;
    addToCart(variantId, 1, btn, function () {
      showAddedState(btn);
    });
  });

  function loadProduct(handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        currentProduct  = product;
        selectedOptions = {};
        populatePopup(product);
        openPopup();
      })
      .catch(function () {
        alert('Could not load product. Please try again.');
      });
  }

  function populatePopup(product) {
    /* Title + SKU */
    if (popTitle) popTitle.textContent = product.title;
    if (popSku)   popSku.textContent   = product.variants[0] && product.variants[0].sku
      ? 'SKU: ' + product.variants[0].sku
      : '';

    /* Price range — show sale price + compare at price */
    if (popPriceRange) {
      var prices = product.variants.map(function (v) { return v.price; });
      var minP = Math.min.apply(null, prices);
      var maxP = Math.max.apply(null, prices);
      var rangeText = minP === maxP
        ? formatMoney(minP)
        : formatMoney(minP) + ' - ' + formatMoney(maxP);
      popPriceRange.textContent = rangeText;
    }
    /* Hide final price until a variant is chosen */
    if (popFinalPrice) popFinalPrice.textContent = '';
    if (popStock) popStock.textContent = '';

    /* Gallery */
    galleryImages = product.images || [];
    currentImg = 0;
    renderGallery();

    /* Options */
    renderOptions(product);

    /* Select first available variant */
    var firstAvail = product.variants.find(function (v) { return v.available; })
      || product.variants[0];
    if (firstAvail) {
      product.options.forEach(function (opt, i) {
        var name = getOptName(opt);
        var val = firstAvail['option' + (i + 1)] || (firstAvail.options && firstAvail.options[i]);
        selectedOptions[name] = val;
      });
      updateForVariant(firstAvail);
      markActiveOptions();
    }

    /* Reset qty */
    if (popQtyInput) popQtyInput.value = 1;
  }

  /* ---- Gallery ---- */
  function renderGallery() {
    if (!popGallery) return;

    // Remove any static img that might be in the markup
    var staticImg = popGallery.querySelector('.variant-popup__gallery-img:not(.variant-popup__gallery-track *)');
    if (staticImg) {
      staticImg.remove();
    }

    var track = popGallery.querySelector('.variant-popup__gallery-track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'variant-popup__gallery-track';
      popGallery.insertBefore(track, popDots);
    }
    track.innerHTML = '';

    if (galleryImages.length > 0) {
      galleryImages.forEach(function (imgSrc, i) {
        var img = document.createElement('img');
        img.className = 'variant-popup__gallery-img';
        img.src = imgSrc;
        img.alt = currentProduct ? currentProduct.title : '';
        img.setAttribute('loading', 'lazy');
        track.appendChild(img);
      });
    }

    // Scroll to the first image initially
    track.scrollLeft = 0;

    /* Dots */
    if (popDots) {
      popDots.innerHTML = '';
      if (galleryImages.length > 1) {
        galleryImages.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'variant-popup__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Image ' + (i + 1));
          dot.addEventListener('click', function () { goToGalleryImg(i); });
          popDots.appendChild(dot);
        });
      }
    }

    // Add scroll event listener to track to update active dot on swipe/scroll
    track.addEventListener('scroll', function () {
      // Only trigger if not currently dragging via mouse to avoid scroll conflicts
      if (isDown) return;
      var width = track.clientWidth;
      if (width === 0) return;
      var newActive = Math.round(track.scrollLeft / width);
      if (newActive !== currentImg) {
        currentImg = newActive;
        updateDots(newActive);
      }
    });

    // Drag-to-scroll behavior for desktop mouse users
    var isDown = false;
    var startX;
    var scrollLeft;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
    });

    track.addEventListener('mouseleave', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      track.style.scrollBehavior = 'smooth';
      track.style.scrollSnapType = 'x mandatory';
      snapToClosest();
    });

    track.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      track.style.scrollBehavior = 'smooth';
      track.style.scrollSnapType = 'x mandatory';
      snapToClosest();
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.5; // Drag speed multiplier
      track.scrollLeft = scrollLeft - walk;
    });

    // Prevent default browser image dragging
    track.querySelectorAll('.variant-popup__gallery-img').forEach(function (img) {
      img.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    });

    function snapToClosest() {
      var width = track.clientWidth;
      if (width === 0) return;
      var targetIdx = Math.round(track.scrollLeft / width);
      track.scrollTo({
        left: targetIdx * width,
        behavior: 'smooth'
      });
      currentImg = targetIdx;
      updateDots(targetIdx);
    }
  }

  function goToGalleryImg(idx) {
    currentImg = idx;
    var track = popGallery ? popGallery.querySelector('.variant-popup__gallery-track') : null;
    if (track) {
      var width = track.clientWidth;
      track.scrollTo({
        left: idx * width,
        behavior: 'smooth'
      });
    }
    updateDots(idx);
  }

  function updateDots(idx) {
    if (popDots) {
      popDots.querySelectorAll('.variant-popup__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }
  }


  /* ---- Option selectors ---- */

  /* Shopify AJAX API returns options as objects {name, position, values} OR strings */
  function getOptName(opt) {
    return typeof opt === 'object' && opt !== null ? opt.name : String(opt);
  }

  function renderOptions(product) {
    if (!popOptions) return;
    popOptions.innerHTML = '';

    // Single-variant products only have a synthetic "Title: Default Title"
    // option — nothing for the shopper to actually choose, so skip it.
    var hasRealOptions = product.options && product.options.length > 0 &&
      !(product.options.length === 1 && (getOptName(product.options[0]) === 'Title' || getOptName(product.options[0]) === 'Default Title'));
    if (!hasRealOptions) return;

    product.options.forEach(function (opt, optIdx) {
      var optionName = getOptName(opt);
      var values = getOptionValues(product, optIdx);
      var isColor = /colou?r|shade|warna/i.test(optionName);

      var group = document.createElement('div');
      group.className = 'variant-popup__option';

      var label = document.createElement('div');
      label.className = 'variant-popup__option-label';
      label.innerHTML = optionName + ': <span data-vp-opt-val="' + optIdx + '"></span>';
      group.appendChild(label);

      var swatchWrap = document.createElement('div');
      swatchWrap.className = isColor ? 'variant-popup__swatches' : 'variant-popup__pills';
      swatchWrap.dataset.optIdx = optIdx;

      values.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.optIdx = optIdx;
        btn.dataset.optVal = val;
        btn.dataset.optName = optionName;

        if (isColor) {
          btn.className = 'variant-popup__swatch';
          var swatchBg, swatchLabel;
          if (val.indexOf('_') !== -1) {
            var parts = val.split('_');
            swatchBg    = '#' + parts[0];
            swatchLabel = parts.slice(1).join('_');
          } else {
            swatchBg    = val;
            swatchLabel = val;
          }
          btn.style.setProperty('--swatch-bg', swatchBg);
          btn.setAttribute('aria-label', swatchLabel);
          btn.dataset.label = swatchLabel;

          if (!isOptionValueAvailable(product, optIdx, val)) {
            btn.classList.add('is-disable');
            btn.innerHTML = '<svg width="37" height="17" viewBox="0 0 37 17" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="38.6762" height="1.8" transform="matrix(-0.920407 0.390961 0.390961 0.920407 35.5978 0)" fill="#40484F"/></svg>';
          }
        } else {
          btn.className = 'variant-popup__pill';
          btn.textContent = val;
        }

        if (!isColor && !isOptionValueAvailable(product, optIdx, val)) {
          btn.classList.add('is-unavailable');
          btn.disabled = true;
        }

        btn.addEventListener('click', function () {
          selectedOptions[optionName] = val;
          markActiveOptions();
          var matched = findMatchingVariant();
          if (matched) {
            updateForVariant(matched);
            if (matched.featured_image && matched.featured_image.position) {
              var imgIdx = matched.featured_image.position - 1;
              if (imgIdx >= 0 && imgIdx < galleryImages.length) {
                goToGalleryImg(imgIdx);
              }
            }
          }
        });

        swatchWrap.appendChild(btn);
      });

      group.appendChild(swatchWrap);
      popOptions.appendChild(group);
    });
  }

  function getOptionValues(product, optIdx) {
    var vals = [];
    product.variants.forEach(function (v) {
      var val = v['option' + (optIdx + 1)] || (v.options && v.options[optIdx]);
      if (val && vals.indexOf(val) === -1) vals.push(val);
    });
    return vals;
  }

  function isOptionValueAvailable(product, optIdx, val) {
    return product.variants.some(function (v) {
      var vVal = v['option' + (optIdx + 1)] || (v.options && v.options[optIdx]);
      return vVal === val && v.available;
    });
  }

  function markActiveOptions() {
    if (!popOptions) return;
    popOptions.querySelectorAll('[data-opt-name]').forEach(function (btn) {
      var optName = btn.dataset.optName;
      var isActive = selectedOptions[optName] === btn.dataset.optVal;
      btn.classList.toggle('is-active', isActive);
    });

    popOptions.querySelectorAll('[data-vp-opt-val]').forEach(function (span) {
      var optIdx = parseInt(span.dataset.vpOptVal, 10);
      var optName = getOptName(currentProduct.options[optIdx]);
      var raw = selectedOptions[optName] || '';
      var display = (raw.indexOf('_') !== -1) ? raw.split('_').slice(1).join('_') : raw;
      span.textContent = display;
    });
  }

  function findMatchingVariant() {
    if (!currentProduct) return null;
    return currentProduct.variants.find(function (v) {
      return currentProduct.options.every(function (opt, i) {
        var name = getOptName(opt);
        var vVal = v['option' + (i + 1)] || (v.options && v.options[i]);
        return vVal === selectedOptions[name];
      });
    }) || null;
  }

  function updateForVariant(variant) {
    /* Update price range with selected variant price */
    if (popPriceRange) {
      popPriceRange.textContent = formatMoney(variant.price);
    }
    
    /* Final price — shown below options on mobile */
    if (popFinalPrice) {
      popFinalPrice.textContent = formatMoney(variant.price);
    }
    /* Stock info — show inventory count from global window.variantInventories mapping */
    if (popStock) {
      var localQty = window.variantInventories && window.variantInventories[variant.id];
      if (typeof localQty === 'number') {
        popStock.textContent = localQty + ' in stock';
      } else if (typeof variant.inventory_quantity === 'number') {
        popStock.textContent = variant.inventory_quantity + ' in stock';
      } else {
        popStock.textContent = '';
      }
    }
    /* SKU */
    if (popSku && variant.sku) popSku.textContent = 'SKU: ' + variant.sku;

    /* ATC button */
    if (popAtcBtn) {
      if (variant.available) {
        popAtcBtn.disabled = false;
        popAtcBtn.textContent = popup.dataset.gwpTierId ? 'CLAIM FREE GIFT' : 'ADD TO CART';
        popAtcBtn.dataset.variantId = variant.id;
      } else {
        popAtcBtn.disabled = true;
        popAtcBtn.textContent = 'OUT OF STOCK';
        delete popAtcBtn.dataset.variantId;
      }
    }
  }

  /* ATC from popup */
  if (popAtcBtn) {
    popAtcBtn.addEventListener('click', function () {
      var variantId = popAtcBtn.dataset.variantId;
      if (!variantId) return;

      /* Gift-With-Purchase mode: cart.liquid flags the popup with a tier id
         before opening it (see openVariantPopupForGift). Qty is always 1 and
         the line carries the tier property so cart.liquid can track it;
         closePopup()'s own cleanup notifies cart.liquid via the
         __gwpOnGiftClaimed/__gwpOnPopupSkipped hooks. */
      if (popup.dataset.gwpTierId) {
        var tierId = popup.dataset.gwpTierId;
        addToCart(variantId, 1, popAtcBtn, function () {
          popup.dataset.gwpClaimed = 'true';
          closePopup();
          if (typeof window.__gwpOnGiftClaimed === 'function') window.__gwpOnGiftClaimed(tierId);
        }, { _freebie: 'true', _bohopana_gwp_tier: tierId });
        return;
      }

      var qty = parseInt(popQtyInput ? popQtyInput.value : 1, 10) || 1;
      addToCart(variantId, qty, popAtcBtn, function () {
        closePopup();
      });
    });
  }

  /* ---- Add to Cart (AJAX) ---- */
  function addToCart(variantId, qty, btn, onSuccess, properties) {
    if (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    }

    var payload = { id: variantId, quantity: qty };
    if (properties) payload.properties = properties;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data && data.description ? data.description : 'Could not add to cart.');
          return data;
        });
      })
      .then(function () {
        updateCartCount();
        if (window.jQuery) {
          window.jQuery('html, body').animate({ scrollTop: 0 }, 400);
          var $p = window.jQuery('#cart-toast-popover');
          $p.addClass('is-show');
          setTimeout(function () { $p.removeClass('is-show'); }, 5000);
        }
        if (onSuccess) onSuccess();
      })
      .catch(function (error) {
        alert(error.message || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      });
  }

  function showAddedState(btn) {
    if (!btn) return;
    var originalText = btn.dataset.originalText || btn.textContent;
    btn.dataset.originalText = originalText;
    btn.textContent = 'ADDED!';
    setTimeout(function () {
      btn.textContent = btn.dataset.originalText || originalText;
    }, 1800);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header-action-btn__badge').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }

  /* ---- Helpers ---- */
  function formatMoney(cents) {
    return 'Rp' + Math.round(cents / 100)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* ================================================================
     PRODUCT CARD SKELETON LOADER
     Handles fading out and removing skeletons once image loads.
  ================================================================ */
  function initSkeletonLoaders() {
    // Handled natively via CSS + HTML onload attribute inside product-card.liquid
  }

  /* ================================================================
     SWATCH RESPONSIVENESS
     Hides/shows swatches based on viewport size.
     - Tablet/mobile (< 1024px): maximum 3 swatches.
     - Desktop (>= 1024px): maximum based on data-swatch-limit.
  ================================================================ */
  function initSwatchResponsiveness() {
    function updateSwatchBadges() {
      var isMobileTablet = window.innerWidth < 1326;
      document.querySelectorAll('.product-card__swatches[data-total-colors]').forEach(function (container) {
        var total = parseInt(container.dataset.totalColors) || 0;
        var desktopLimit = parseInt(container.dataset.swatchLimit) || 5;
        var limit = isMobileTablet ? Math.min(3, desktopLimit) : desktopLimit;

        var swatches = container.querySelectorAll('.product-card__swatch');
        swatches.forEach(function (swatch, index) {
          if (index >= limit) {
            swatch.style.display = 'none';
          } else {
            swatch.style.display = '';
          }
        });

        var moreBadge = container.querySelector('.product-card__swatch-more');
        if (total > limit) {
          var extra = total - limit;
          if (!moreBadge) {
            moreBadge = document.createElement('span');
            moreBadge.className = 'product-card__swatch-more';
            container.appendChild(moreBadge);
          }
          moreBadge.textContent = '+' + extra;
          moreBadge.setAttribute('aria-label', extra + ' more shades');
          moreBadge.style.display = '';
        } else {
          if (moreBadge) {
            moreBadge.style.display = 'none';
          }
        }
      });
    }

    updateSwatchBadges();
    window.addEventListener('resize', updateSwatchBadges);
    document.addEventListener('shopify:section:load', updateSwatchBadges);
  }

  /* ================================================================
     INIT
     ================================================================ */
  function initProductCardFeatures() {
    initCountdowns();
    initFeaturedCarousels();
    initSkeletonLoaders();
    initSwatchResponsiveness();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardFeatures);
  } else {
    initProductCardFeatures();
  }
})();
